"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _components = require("@indigenux/design/components");
var _layouts = require("@indigenux/design/layouts");
var _hole = _interopRequireDefault(require("../../img/errors/404-hole.jpg"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
/* Images */

const NotFound = () => {
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_layouts.Main, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.PageHeader, {
      Category: "Error",
      children: "This doesn't have to be the end."
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)("section", {
      className: "page-header page-header-modern page-header-background page-header-background-md overlay overlay-color-dark overlay-show overlay-op-8 http-error m-0",
      style: {
        backgroundImage: "url(".concat(_hole.default, ")"),
        backgroundAttachment: 'fixed',
        backgroundPosition: 'center center'
      },
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "container",
        children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
          className: "row",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "col-md-8 mt-4 mt-md-0",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Heading, {
              level: "h2",
              cssName: "text-color-light",
              children: "404"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Heading, {
              level: "h1",
              cssName: "text-color-primary",
              children: "Now you've done it"
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
              className: "sub-title",
              children: "You've fallen into our rabbit hole."
            }), /*#__PURE__*/(0, _jsxRuntime.jsx)("p", {
              className: "text-color-danger",
              children: "The page your looking for doesn't exist, but this bunny sure is cute!"
            })]
          }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
            className: "col-md-4 mt-4 mt-md-0",
            children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Heading, {
              level: "h4",
              cssName: "text-color-light",
              children: "Links to get you back on track"
            }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("ul", {
              className: "nav nav-list flex-column",
              children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                className: "nav-item",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Link, {
                  className: "nav-link text-color-light",
                  href: "/",
                  children: "Home"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                className: "nav-item",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Link, {
                  className: "nav-link text-color-light",
                  href: "/success",
                  children: "About Us"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                className: "nav-item",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Link, {
                  className: "nav-link text-color-light",
                  href: "/innovate",
                  children: "Technology"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                className: "nav-item",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Link, {
                  className: "nav-link text-color-light",
                  href: "/creative",
                  children: "Design"
                })
              }), /*#__PURE__*/(0, _jsxRuntime.jsx)("li", {
                className: "nav-item",
                children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_components.Link, {
                  className: "nav-link text-color-light",
                  href: "/contact-us",
                  children: "Contact Us"
                })
              })]
            })]
          })]
        })
      })
    })]
  });
};
var _default = exports.default = NotFound;